import dayjs from 'dayjs';
import type { Task } from '@stromo/shared';

/**
 * Aufgabe ist im Verzug, wenn das geplante Bauenddatum überschritten ist
 * UND der Status nicht "completed" ist. UI-Hinweis, ist nicht der gestorte Status.
 */
export function isTaskDelayed(task: Pick<Task, 'schedule_end' | 'status'>): boolean {
  if (task.status === 'completed') return false;
  if (!task.schedule_end) return false;
  return dayjs(task.schedule_end).isBefore(dayjs(), 'day');
}

/**
 * Differenz in Kalendertagen zwischen Bauzeit-Ende und interner Planung.
 * Negativ = interne Planung früher fertig, positiv = später.
 */
export function diffDays(
  scheduleEnd: string | null,
  internalEnd: string | null,
): number | null {
  if (!scheduleEnd || !internalEnd) return null;
  return dayjs(internalEnd).diff(dayjs(scheduleEnd), 'day');
}
